<template>
  <div class="mx-auto flex flex-col">
    <AddNewUser></AddNewUser>
    <ChangeGarmentColorPricing></ChangeGarmentColorPricing>
    <ChangeSetupFee></ChangeSetupFee>
    <ChangeAddlOptionsPricing></ChangeAddlOptionsPricing>
    <ChangeColorPricing></ChangeColorPricing>
  </div>
</template>

<script>
import AddNewUser from '@/components/admin/AddNewUser'
import ChangeSetupFee from '@/components/admin/ChangeSetupFee'
import ChangeGarmentColorPricing from '@/components/admin/ChangeGarmentColorPricing'
import ChangeAddlOptionsPricing from '@/components/admin/ChangeAddlOptionsPricing'
import ChangeColorPricing from '@/components/admin/ChangeColorPricing'
export default {
  name: 'Admin',
  components: {
    AddNewUser,
    ChangeGarmentColorPricing,
    ChangeSetupFee,
    ChangeAddlOptionsPricing,
    ChangeColorPricing
  }
}
</script>
